/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CustomQueryOptions,
  DefaultBodyType,
  FetchError,
  HttpResponseResolver,
  QueryStringFormat,
  UseMutationOptions,
  UseQueryOptions,
  fetcher,
  http,
  useMutation,
  useQuery,
  useQueryClient,
} from "@oaknorth/util-rest";
import { Scope } from "@oaknorth/util-testing-library";
import { useAccessToken } from "@oaknorth/util-user";
import type { SetOptional } from "type-fest";

import {
  BorrowerSortField,
  BorrowerSpreadAuditResponse,
  ExcludedBorrowerReasonsResponse,
  ExcludedBorrowersResponse,
  HTTPValidationError,
  SortOrder,
} from "./data-contracts";

export type BorrowerSpreadAuditError = FetchError<HTTPValidationError>;

export type BorrowerSpreadAuditVariables = {
  query?: never;
  path: { legalEntityId: string };
};

function buildBorrowerSpreadAuditQueryKey(
  variables: SetOptional<BorrowerSpreadAuditVariables, "query">,
): [string] | [string, unknown] {
  const { legalEntityId } = variables.path;
  const path = `/api/polaris/api/borrower-audit/v1/borrower/${legalEntityId}/spread-audit`;

  if (variables.query) {
    return [path, variables.query];
  }
  return [path];
}

/**
 * No description
 *
 * @name BorrowerSpreadAudit
 * @summary Get Borrower Spread Audit
 * @request GET:/borrower-audit/v1/borrower/{legal_entity_id}/spread-audit
 * @response `200` `BorrowerSpreadAuditResponse` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useQueryBorrowerSpreadAudit(
  variables: BorrowerSpreadAuditVariables,
  options: Omit<
    UseQueryOptions<BorrowerSpreadAuditResponse, BorrowerSpreadAuditError>,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<BorrowerSpreadAuditResponse> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildBorrowerSpreadAuditQueryKey(variables);
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<
    BorrowerSpreadAuditResponse,
    BorrowerSpreadAuditError,
    BorrowerSpreadAuditResponse
  >({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<BorrowerSpreadAuditResponse>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the BorrowerSpreadAudit query
 * @name BorrowerSpreadAudit
 * @summary Get Borrower Spread Audit
 * @request GET:/borrower-audit/v1/borrower/{legal_entity_id}/spread-audit
 * @response `200` `BorrowerSpreadAuditResponse` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useLazyQueryBorrowerSpreadAudit(
  options: UseMutationOptions<
    BorrowerSpreadAuditResponse,
    BorrowerSpreadAuditError,
    BorrowerSpreadAuditVariables
  > &
    CustomQueryOptions<BorrowerSpreadAuditResponse> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: (variables: BorrowerSpreadAuditVariables) => {
      const [path] = buildBorrowerSpreadAuditQueryKey(variables);
      return fetcher<BorrowerSpreadAuditResponse>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryBorrowerSpreadAudit` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryBorrowerSpreadAudit() {
  const queryClient = useQueryClient();
  return (variables: SetOptional<BorrowerSpreadAuditVariables, "query">) =>
    queryClient.invalidateQueries({
      queryKey: buildBorrowerSpreadAuditQueryKey(variables),
    });
}

/**
 * Hook returning a function to update the data for `useQueryBorrowerSpreadAudit` (e.g. after a mutation)
 */
export function useUpdateQueryBorrowerSpreadAudit() {
  const queryClient = useQueryClient();
  return (
    variables: BorrowerSpreadAuditVariables,
    data:
      | BorrowerSpreadAuditResponse
      | undefined
      | ((
          oldData: BorrowerSpreadAuditResponse | undefined,
        ) => BorrowerSpreadAuditResponse | undefined),
  ) =>
    queryClient.setQueryData(buildBorrowerSpreadAuditQueryKey(variables), data);
}

/**
 * Returns a function that will mock the http request made in `useQueryBorrowerSpreadAudit` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockBorrowerSpreadAudit({
  variables,
  status,
  response,
}: {
  variables: BorrowerSpreadAuditVariables;
  status: number;
  response: BorrowerSpreadAuditResponse | BorrowerSpreadAuditError;
}): (scope: Scope) => Scope {
  const [path] = buildBorrowerSpreadAuditQueryKey(variables);

  if (variables.query) {
    return (scope: Scope) => {
      return scope
        .get(path)
        .query(variables)
        .reply(status, response || undefined);
    };
  }

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryBorrowerSpreadAudit`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param variables Path/query parameters for the endpoint.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswBorrowerSpreadAudit(
 *   ({ request }) => HttpResponse.json({ result: "ok" }),
 *   { path: { id: "123" }}
 * );
 */
export function getMockMswBorrowerSpreadAudit(
  handler: HttpResponseResolver<
    { [K in keyof BorrowerSpreadAuditVariables["path"]]: string },
    DefaultBodyType,
    BorrowerSpreadAuditResponse | null | BorrowerSpreadAuditError
  >,
  variables: SetOptional<BorrowerSpreadAuditVariables, "query">,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildBorrowerSpreadAuditQueryKey(variables);
  return http.get<
    { [K in keyof BorrowerSpreadAuditVariables["path"]]: string },
    DefaultBodyType,
    BorrowerSpreadAuditResponse | null | BorrowerSpreadAuditError
  >(path, handler, options);
}

export type BorrowerSpreadAuditDownloadError = FetchError<HTTPValidationError>;

export type BorrowerSpreadAuditDownloadVariables = {
  query?: never;
  path: { legalEntityId: string; inputFileId: number };
};

function buildBorrowerSpreadAuditDownloadQueryKey(
  variables: SetOptional<BorrowerSpreadAuditDownloadVariables, "query">,
): [string] | [string, unknown] {
  const { legalEntityId, inputFileId } = variables.path;
  const path = `/api/polaris/api/borrower-audit/v1/borrower/${legalEntityId}/spread-audit-download/${inputFileId}`;

  if (variables.query) {
    return [path, variables.query];
  }
  return [path];
}

/**
 * No description
 *
 * @name BorrowerSpreadAuditDownload
 * @summary Download Borrower Spread Audit
 * @request GET:/borrower-audit/v1/borrower/{legal_entity_id}/spread-audit-download/{input_file_id}
 * @response `200` `any` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useQueryBorrowerSpreadAuditDownload(
  variables: BorrowerSpreadAuditDownloadVariables,
  options: Omit<
    UseQueryOptions<any, BorrowerSpreadAuditDownloadError>,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<any> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildBorrowerSpreadAuditDownloadQueryKey(variables);
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<any, BorrowerSpreadAuditDownloadError, any>({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<any>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the BorrowerSpreadAuditDownload query
 * @name BorrowerSpreadAuditDownload
 * @summary Download Borrower Spread Audit
 * @request GET:/borrower-audit/v1/borrower/{legal_entity_id}/spread-audit-download/{input_file_id}
 * @response `200` `any` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useLazyQueryBorrowerSpreadAuditDownload(
  options: UseMutationOptions<
    any,
    BorrowerSpreadAuditDownloadError,
    BorrowerSpreadAuditDownloadVariables
  > &
    CustomQueryOptions<any> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: (variables: BorrowerSpreadAuditDownloadVariables) => {
      const [path] = buildBorrowerSpreadAuditDownloadQueryKey(variables);
      return fetcher<any>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryBorrowerSpreadAuditDownload` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryBorrowerSpreadAuditDownload() {
  const queryClient = useQueryClient();
  return (
    variables: SetOptional<BorrowerSpreadAuditDownloadVariables, "query">,
  ) =>
    queryClient.invalidateQueries({
      queryKey: buildBorrowerSpreadAuditDownloadQueryKey(variables),
    });
}

/**
 * Hook returning a function to update the data for `useQueryBorrowerSpreadAuditDownload` (e.g. after a mutation)
 */
export function useUpdateQueryBorrowerSpreadAuditDownload() {
  const queryClient = useQueryClient();
  return (
    variables: BorrowerSpreadAuditDownloadVariables,
    data: any | undefined | ((oldData: any | undefined) => any | undefined),
  ) =>
    queryClient.setQueryData(
      buildBorrowerSpreadAuditDownloadQueryKey(variables),
      data,
    );
}

/**
 * Returns a function that will mock the http request made in `useQueryBorrowerSpreadAuditDownload` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockBorrowerSpreadAuditDownload({
  variables,
  status,
  response,
}: {
  variables: BorrowerSpreadAuditDownloadVariables;
  status: number;
  response: any | BorrowerSpreadAuditDownloadError;
}): (scope: Scope) => Scope {
  const [path] = buildBorrowerSpreadAuditDownloadQueryKey(variables);

  if (variables.query) {
    return (scope: Scope) => {
      return scope
        .get(path)
        .query(variables)
        .reply(status, response || undefined);
    };
  }

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryBorrowerSpreadAuditDownload`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param variables Path/query parameters for the endpoint.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswBorrowerSpreadAuditDownload(
 *   ({ request }) => HttpResponse.json({ result: "ok" }),
 *   { path: { id: "123" }}
 * );
 */
export function getMockMswBorrowerSpreadAuditDownload(
  handler: HttpResponseResolver<
    { [K in keyof BorrowerSpreadAuditDownloadVariables["path"]]: string },
    DefaultBodyType,
    any | null | BorrowerSpreadAuditDownloadError
  >,
  variables: SetOptional<BorrowerSpreadAuditDownloadVariables, "query">,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildBorrowerSpreadAuditDownloadQueryKey(variables);
  return http.get<
    { [K in keyof BorrowerSpreadAuditDownloadVariables["path"]]: string },
    DefaultBodyType,
    any | null | BorrowerSpreadAuditDownloadError
  >(path, handler, options);
}

export type GetExcludedBorrowersError = FetchError<HTTPValidationError>;

export type GetExcludedBorrowersVariables = {
  query?: {
    /**
     * Page
     * @default 1
     */
    page?: number;
    /**
     * Page Size
     * @default 25
     */
    page_size?: number;
    /**
     * The field to sort by
     * @default "borrower_name"
     */
    sort_field?: BorrowerSortField;
    /**
     * Sort order of sorted field, ascending or descending, ASC or DESC
     * @default "ASC"
     */
    sort_order?: SortOrder;
    /**
     * Borrower Name
     * The search string used to filter borrower names
     */
    borrower_name?: string | null;
  };
  path?: never;
};

function buildGetExcludedBorrowersQueryKey(
  variables: SetOptional<GetExcludedBorrowersVariables, "query">,
): [string] | [string, unknown] {
  const path = `/api/polaris/api/borrower-audit/v1/excluded-borrowers`;

  if (variables.query) {
    return [path, variables.query];
  }
  return [path];
}

/**
 * No description
 *
 * @name GetExcludedBorrowers
 * @summary Get Excluded Borrowers
 * @request GET:/borrower-audit/v1/excluded-borrowers
 * @response `200` `ExcludedBorrowersResponse` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useQueryGetExcludedBorrowers(
  variables: GetExcludedBorrowersVariables,
  options: Omit<
    UseQueryOptions<ExcludedBorrowersResponse, GetExcludedBorrowersError>,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<ExcludedBorrowersResponse> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildGetExcludedBorrowersQueryKey(variables);
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<
    ExcludedBorrowersResponse,
    GetExcludedBorrowersError,
    ExcludedBorrowersResponse
  >({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<ExcludedBorrowersResponse>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the GetExcludedBorrowers query
 * @name GetExcludedBorrowers
 * @summary Get Excluded Borrowers
 * @request GET:/borrower-audit/v1/excluded-borrowers
 * @response `200` `ExcludedBorrowersResponse` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useLazyQueryGetExcludedBorrowers(
  options: UseMutationOptions<
    ExcludedBorrowersResponse,
    GetExcludedBorrowersError,
    GetExcludedBorrowersVariables
  > &
    CustomQueryOptions<ExcludedBorrowersResponse> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: (variables: GetExcludedBorrowersVariables) => {
      const [path] = buildGetExcludedBorrowersQueryKey(variables);
      return fetcher<ExcludedBorrowersResponse>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryGetExcludedBorrowers` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryGetExcludedBorrowers() {
  const queryClient = useQueryClient();
  return (variables: SetOptional<GetExcludedBorrowersVariables, "query">) =>
    queryClient.invalidateQueries({
      queryKey: buildGetExcludedBorrowersQueryKey(variables),
    });
}

/**
 * Hook returning a function to update the data for `useQueryGetExcludedBorrowers` (e.g. after a mutation)
 */
export function useUpdateQueryGetExcludedBorrowers() {
  const queryClient = useQueryClient();
  return (
    variables: GetExcludedBorrowersVariables,
    data:
      | ExcludedBorrowersResponse
      | undefined
      | ((
          oldData: ExcludedBorrowersResponse | undefined,
        ) => ExcludedBorrowersResponse | undefined),
  ) =>
    queryClient.setQueryData(
      buildGetExcludedBorrowersQueryKey(variables),
      data,
    );
}

function normaliseGetExcludedBorrowersVariable(
  query: GetExcludedBorrowersVariables["query"],
) {
  if (query === undefined) {
    return {};
  }
  return Object.entries(query).reduce(
    (acc, [currentParamKey, currentParamValue]) => {
      if (Array.isArray(currentParamValue) && currentParamValue.length === 1) {
        return { ...acc, [currentParamKey]: currentParamValue[0] };
      }
      return acc;
    },
    query,
  );
}

/**
 * Returns a function that will mock the http request made in `useQueryGetExcludedBorrowers` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockGetExcludedBorrowers({
  variables,
  status,
  response,
}: {
  variables: GetExcludedBorrowersVariables;
  status: number;
  response: ExcludedBorrowersResponse | GetExcludedBorrowersError;
}): (scope: Scope) => Scope {
  const [path] = buildGetExcludedBorrowersQueryKey(variables);

  if (variables.query) {
    return (scope: Scope) => {
      return scope
        .get(path)
        .query(normaliseGetExcludedBorrowersVariable(variables.query))
        .reply(status, response || undefined);
    };
  }

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryGetExcludedBorrowers`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param variables Path/query parameters for the endpoint.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswGetExcludedBorrowers(
 *   ({ request }) => HttpResponse.json({ result: "ok" }),
 *   { path: { id: "123" }}
 * );
 */
export function getMockMswGetExcludedBorrowers(
  handler: HttpResponseResolver<
    { [K in keyof GetExcludedBorrowersVariables["path"]]: string },
    DefaultBodyType,
    ExcludedBorrowersResponse | null | GetExcludedBorrowersError
  >,
  variables: SetOptional<GetExcludedBorrowersVariables, "query">,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildGetExcludedBorrowersQueryKey(variables);
  return http.get<
    { [K in keyof GetExcludedBorrowersVariables["path"]]: string },
    DefaultBodyType,
    ExcludedBorrowersResponse | null | GetExcludedBorrowersError
  >(path, handler, options);
}

export type GetBorrowerExclusionReasonsError = FetchError<HTTPValidationError>;

export type GetBorrowerExclusionReasonsVariables = {
  query?: never;
  path: { legalEntityId: string };
};

function buildGetBorrowerExclusionReasonsQueryKey(
  variables: SetOptional<GetBorrowerExclusionReasonsVariables, "query">,
): [string] | [string, unknown] {
  const { legalEntityId } = variables.path;
  const path = `/api/polaris/api/borrower-audit/v1/excluded-borrowers/${legalEntityId}`;

  if (variables.query) {
    return [path, variables.query];
  }
  return [path];
}

/**
 * No description
 *
 * @name GetBorrowerExclusionReasons
 * @summary Get Borrower Exclusion Reasons
 * @request GET:/borrower-audit/v1/excluded-borrowers/{legal_entity_id}
 * @response `200` `ExcludedBorrowerReasonsResponse` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useQueryGetBorrowerExclusionReasons(
  variables: GetBorrowerExclusionReasonsVariables,
  options: Omit<
    UseQueryOptions<
      ExcludedBorrowerReasonsResponse,
      GetBorrowerExclusionReasonsError
    >,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<ExcludedBorrowerReasonsResponse> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildGetBorrowerExclusionReasonsQueryKey(variables);
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<
    ExcludedBorrowerReasonsResponse,
    GetBorrowerExclusionReasonsError,
    ExcludedBorrowerReasonsResponse
  >({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<ExcludedBorrowerReasonsResponse>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the GetBorrowerExclusionReasons query
 * @name GetBorrowerExclusionReasons
 * @summary Get Borrower Exclusion Reasons
 * @request GET:/borrower-audit/v1/excluded-borrowers/{legal_entity_id}
 * @response `200` `ExcludedBorrowerReasonsResponse` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useLazyQueryGetBorrowerExclusionReasons(
  options: UseMutationOptions<
    ExcludedBorrowerReasonsResponse,
    GetBorrowerExclusionReasonsError,
    GetBorrowerExclusionReasonsVariables
  > &
    CustomQueryOptions<ExcludedBorrowerReasonsResponse> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: (variables: GetBorrowerExclusionReasonsVariables) => {
      const [path] = buildGetBorrowerExclusionReasonsQueryKey(variables);
      return fetcher<ExcludedBorrowerReasonsResponse>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryGetBorrowerExclusionReasons` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryGetBorrowerExclusionReasons() {
  const queryClient = useQueryClient();
  return (
    variables: SetOptional<GetBorrowerExclusionReasonsVariables, "query">,
  ) =>
    queryClient.invalidateQueries({
      queryKey: buildGetBorrowerExclusionReasonsQueryKey(variables),
    });
}

/**
 * Hook returning a function to update the data for `useQueryGetBorrowerExclusionReasons` (e.g. after a mutation)
 */
export function useUpdateQueryGetBorrowerExclusionReasons() {
  const queryClient = useQueryClient();
  return (
    variables: GetBorrowerExclusionReasonsVariables,
    data:
      | ExcludedBorrowerReasonsResponse
      | undefined
      | ((
          oldData: ExcludedBorrowerReasonsResponse | undefined,
        ) => ExcludedBorrowerReasonsResponse | undefined),
  ) =>
    queryClient.setQueryData(
      buildGetBorrowerExclusionReasonsQueryKey(variables),
      data,
    );
}

/**
 * Returns a function that will mock the http request made in `useQueryGetBorrowerExclusionReasons` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockGetBorrowerExclusionReasons({
  variables,
  status,
  response,
}: {
  variables: GetBorrowerExclusionReasonsVariables;
  status: number;
  response: ExcludedBorrowerReasonsResponse | GetBorrowerExclusionReasonsError;
}): (scope: Scope) => Scope {
  const [path] = buildGetBorrowerExclusionReasonsQueryKey(variables);

  if (variables.query) {
    return (scope: Scope) => {
      return scope
        .get(path)
        .query(variables)
        .reply(status, response || undefined);
    };
  }

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryGetBorrowerExclusionReasons`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param variables Path/query parameters for the endpoint.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswGetBorrowerExclusionReasons(
 *   ({ request }) => HttpResponse.json({ result: "ok" }),
 *   { path: { id: "123" }}
 * );
 */
export function getMockMswGetBorrowerExclusionReasons(
  handler: HttpResponseResolver<
    { [K in keyof GetBorrowerExclusionReasonsVariables["path"]]: string },
    DefaultBodyType,
    ExcludedBorrowerReasonsResponse | null | GetBorrowerExclusionReasonsError
  >,
  variables: SetOptional<GetBorrowerExclusionReasonsVariables, "query">,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildGetBorrowerExclusionReasonsQueryKey(variables);
  return http.get<
    { [K in keyof GetBorrowerExclusionReasonsVariables["path"]]: string },
    DefaultBodyType,
    ExcludedBorrowerReasonsResponse | null | GetBorrowerExclusionReasonsError
  >(path, handler, options);
}
